export const ALLOWED_IMPORT_FILE_TYPES = 'text/csv';
